import OrgnizationEntry from './OrgnizationEntry'

export default OrgnizationEntry
